<div [class.d-none]="!showDesktopNavigationForMobile" [class.d-lg-flex]="rightSideText" [class.d-lg-block]="!rightSideText">
  <div rt="top-bar-navigation-container" class="top-bar-navigation-container" [style.background-color]="backgroundColor">
    <div class="container px-0">
      <div
        class="d-inline-flex align-items-center navigation-item-container"
        *ngFor="let item of navigationItems; index as i"
        [class.active]="item.active"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
      >
        <a
          class="navigation-item text-grey"
          *ngIf="item.route && item.children == null"
          href=""
          [routerLink]="item.route"
          [routerLinkActive]="['text-dark-grey']"
          [routerLinkActiveOptions]="routerLinkActiveOptions"
          [queryParams]="item.queryParams ? item.queryParams : null"
          [queryParamsHandling]="preserveQueryParams === true ? 'preserve' : null"
          >{{ item.label }}</a
        >

        <a
          class="navigation-item text-grey cursor-pointer"
          [class.text-dark-grey]="item.active"
          [class.font-weight-bold]="item.active"
          (click)="clickActive(item)"
          *ngIf="item.click && !item.route && item.children == null"
        >
          {{ item.label }}
        </a>

        <div
          class="nav-item"
          ngbDropdown
          placement="bottom-left"
          container="body"
          *ngIf="item.children"
          [routerLinkActive]="['children-active']"
          [routerLinkActiveOptions]="routerLinkActiveOptions"
        >
          <a class="nav-link navigation-item text-grey cursor-pointer" ngbDropdownToggle>
            {{ item.label }}
            <i class="icon-carrot text-grey small ml-1"></i>
          </a>
          <div ngbDropdownMenu class="dropdown-menu">
            <a
              class="dropdown-item"
              *ngFor="let children of item.children"
              href=""
              [routerLinkActive]="['font-weight-bold']"
              [routerLinkActiveOptions]="routerLinkActiveOptions"
              [routerLink]="children.route"
              [queryParams]="children.queryParams ? children.queryParams : null"
              [queryParamsHandling]="preserveQueryParams === true ? 'preserve' : null"
              >{{ children.label }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div rt="right-side-text" *ngIf="rightSideText" [ngClass]="rightsideTextClass">
    {{ rightSideText }}
  </div>
</div>

<div
  class="d-lg-none pt-1 mb-2 bb-light"
  [class.d-none]="showDesktopNavigationForMobile"
  *ngIf="!usePillsForMobileNav"
  [style.background-color]="backgroundColor"
  ngbDropdown
  placement="bottom-left"
>
  <div class="container">
    <div *ngIf="rightSideText" [ngClass]="rightsideTextClass">{{ rightSideText }}</div>

    <div class="d-flex align-items-center fs-24" ngbDropdownToggle>
      <div class="teko font-weight-500 fs-32">{{ selectedLabel }}</div>
      <i class="icon-carrot ml-2 fs-14"></i>
      <!-- for when we have something to do on a different page -->
      <!-- <div class="ml-2" style="border: 1px solid red; border-radius: 50%; padding: 2px; background: red"></div> -->
    </div>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
      <button
        *ngFor="let item of navigationItems; index as i"
        [value]="item.route"
        [selected]="rla.isActive"
        [routerLink]="item.route"
        [queryParamsHandling]="preserveQueryParams === true ? 'preserve' : null"
        routerLinkActive
        #rla="routerLinkActive"
        ngbDropdownItem
        (click)="selectedLabel = item.label"
      >
        {{ item.label }}
      </button>
    </div>
  </div>
</div>
<div class="d-lg-none mb-3" *ngIf="usePillsForMobileNav">
  <div class="mb-2" *ngIf="rightSideText" [ngClass]="rightsideTextClass">{{ rightSideText }}</div>
  <div [ngClass]="{ 'ml-n3 mr-n3': pillOffset != 0 }">
    <swiper [config]="config" [index]="swiperIndex">
      <div *ngFor="let item of navigationItems; index as i">
        <a
          class="badge badge-pill badge-custom"
          [routerLink]="item.route"
          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="routerLinkActiveOptions"
          [queryParamsHandling]="preserveQueryParams === true ? 'preserve' : null"
          (click)="swiperIndex = i"
          >{{ item.label }}</a
        >
      </div>
    </swiper>
  </div>
</div>
